// PROMPT-134: Central API Base Resolver - Host-Based API Calls (No localhost)
export function getApiBaseUrl() {
  // Highest priority: explicit env override
  if (process.env.REACT_APP_API_BASE_URL) {
    console.log('[API Base] Using environment override:', process.env.REACT_APP_API_BASE_URL);
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Use browser runtime host
  const protocol = window.location.protocol;   // http or https
  const hostname = window.location.hostname;   // 192.168.1.6 / domain
  
  // For local development, use port 9000 (direct API)
  // For server deployment, use HTTPS for mysmpp.in, HTTP for IP
  const isLocalDevelopment = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
  const isServerDomain = hostname === 'mysmpp.in' || hostname === 'www.mysmpp.in';
  const isServerIP = hostname === '148.113.24.219';
  
  // Determine backend host
  const backendHost = isLocalDevelopment ? 'localhost' : hostname;
  
  // Build URL - don't include port 80/443 for standard HTTP/HTTPS
  let backendPort;
  if (isLocalDevelopment) {
    backendPort = '9000';
  } else if ((isServerDomain || isServerIP) && window.location.port === '3000') {
    backendPort = ''; // No port for production (uses 80/443)
  } else {
    backendPort = window.location.port || '';
  }
  
  // Force HTTPS for mysmpp.in domain
  const useProtocol = isServerDomain ? 'https:' : protocol;
  const portSuffix = backendPort ? `:${backendPort}` : '';
  const dynamicUrl = `${useProtocol}//${backendHost}${portSuffix}/api/v1`;
  
  // PROMPT-134: Enhanced debugging for LAN issues
  console.log('=== API BASE RESOLUTION DEBUG ===');
  console.log('[API Base] Current window URL:', window.location.href);
  console.log('[API Base] Protocol:', protocol);
  console.log('[API Base] Hostname:', hostname);
  console.log('[API Base] Is Local Development:', isLocalDevelopment);
  console.log('[API Base] Backend Host:', backendHost);
  console.log('[API Base] Backend Port:', backendPort);
  console.log('[API Base] Use Protocol:', useProtocol);
  console.log('[API Base] Dynamic URL:', dynamicUrl);
  console.log('================================');
  
  return dynamicUrl;
}

// PROMPT-134: Helper function for API endpoints
export function getApiEndpoint(endpoint) {
  // For all endpoints, use the regular API base URL
  const baseUrl = getApiBaseUrl();
  
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  // Combine base URL with endpoint (base URL already includes /api/v1)
  const fullUrl = `${baseUrl}/${cleanEndpoint}`;
  
  console.log('[API Base] Full endpoint URL:', fullUrl);
  return fullUrl;
}

// Authenticated fetch wrapper - attaches JWT token to fetch() calls
export function authFetch(url, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers });
}

// PROMPT-134: Export for backward compatibility
export default getApiBaseUrl;
